<template>
  <div class="main-content">
    <select-meter class="select-meter"></select-meter>
    <div class="other-cards">
      <div class="day-cost">
        <div class="card-title">
          <div class="card-icon"><img :src="base_url + '/images/icons/15.png'" alt=""></div>
          <span>當{{ translateTimeFormat(time_format) }}電費預估</span>
        </div>
        <div class="card-content">${{ electricity_bill }}</div>
      </div>
      <div class="day-consumption">
        <div class="card-title">
          <div class="card-icon"><img :src="base_url + '/images/icons/16.png'" alt=""></div>
          <span>當{{ translateTimeFormat(time_format) }}消耗</span>
        </div>
        <div class="card-content">
          <div class="circuits-data" v-for="meterUsage, index in dailyCircuitUsage" :key="index">
            <span>{{ meterUsage.alias }}</span><br>
            <span>{{ meterUsage.cumulative_ep }} kWh</span>
          </div>
        </div>
      </div>
    </div>

    <consumption-pie-chart class="pie-chart card-shadow d-flex"></consumption-pie-chart>

    <render-chart class="render-chart chart-padding" />

  </div>
</template>

<script>
import SelectMeter from '../buttons/SelectMeter.vue';
import ConsumptionPieChart from '../charts/ConsumptionPieChart.vue';
import ElectricityUsageLineChart from '../charts/ElectricityUsageLineChart.vue';
import { axiosMixins } from '../mixins/axiosErrorMessage';
import RenderChart from '../charts/RenderChart.vue';
import { powerCostCalculation } from '../mixins/powerCostCalculation';

export default {
  components: {
    SelectMeter,
    ConsumptionPieChart,
    ElectricityUsageLineChart,
    RenderChart
  },
  mixins: [axiosMixins, powerCostCalculation],
  data() {
    return {
      base_url: base_url,
      electricity_bill: null,
      isShowInput: false,
      region_name: "",
    };
  },
  mounted() {
  },
  computed: {
    dailyCircuitUsage() {
      const circuits = this.$store.getters.selectedMeter.bx_circuits;
      if (!circuits) { return null; }
      const circuit_keys = Object.keys(circuits);
      let data = [];
      let count = 0;

      for (let i = 0; i < circuit_keys.length; i++) {
        let cumulative_data = [];
        cumulative_data = circuits[i].cumulative_data.filter(value => value.cumulative_ep !== "");
        if (cumulative_data.length > 0) {
          let cumulative_ep = cumulative_data[cumulative_data.length - 1].cumulative_ep;
          if (i === 0) {
            this.electricity_bill = this.calculateElectricityBill(cumulative_ep, this.$store.getters.billMode);
          }
          data[count] = {
            alias: circuits[i].alias,
            cumulative_ep: Math.abs(cumulative_ep),
          };
          count++
        }
      }

      return data;
    },
    time_format() {
      return this.$store.getters.historicalDataTimeFormat;
    }
  },
  watch: {
    deep: true,
  },
  methods: {
    translateTimeFormat(time_format) {
      switch (time_format) {
        case "day":
          return "日";
        case "week":
          return "週";
        case "month":
          return "月";
        case "year":
          return "年";
        default:
          return;
      }
    },
  }
};
</script>

<style scoped>
.main-content {
  width: 100%;
  padding: 1vh 2vw 1vh 2vw;
}

.main-content .card-shadow {
  border-radius: 1rem;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding: 1%;
}

.main-content .chart-padding {
  padding: 0 2% 5% 2%;
}

.main-content .select-meter {
  height: 15vh;
  margin-bottom: 1vh;
}

.main-content .other-cards {
  height: 35vh;
  min-height: 315px;
}

.main-content .other-cards > div {
  border-radius: .5rem;
}

.main-content .other-cards .card-title {
  display: flex;
  align-items: center;
  padding-left: 4%;
  margin: 0;
  min-height: 2.5rem;
  height: 15%;
}

.main-content .other-cards .card-title > span {
  color: white;
  font-size: .9rem;
  font-weight: bolder;
  margin-left: .5rem;
}

.main-content .other-cards .card-title .card-icon {
  width: 1.8rem;
  height: 1.8rem;
  background-color: white;
  border-radius: .3rem;
}

.main-content .other-cards .card-title .card-icon > img {
  margin: 15%;
  width: 70%;
  height: 70%;
}

.main-content .other-cards .card-content {
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  font-size: 1.5rem;
}

.main-content .other-cards .card-content .circuits-data {
  margin-bottom: 1%;
  min-width: 35%;
  max-width: 45%;
}

.main-content .other-cards .day-cost {
  background-color: #0287d6;
  height: 25%;
  margin-bottom: 2%;
}

.main-content .other-cards .day-consumption {
  background-color: #069610;
  height: 73%;
}

.main-content .other-cards .day-consumption > .card-content {
  font-size: .8rem;
  height: calc(100% - 2.5rem);
}

.main-content .pie-chart {
  margin-top: 1vh;
  height: 20vh;
  min-height: 190px;
}

.main-content .render-chart {
  margin-top: 1vh;
  height: 25vh;
  min-height: 230px;
}
</style>
